/**
 * title Lazy Load
 * description Lazy Loading Images
 **/
import { initLazyLoad } from "./modules/lazy-load";

if (document.readyState !== "loading") {
	initLazyLoad();
}

import reframe from "reframe.js";
reframe(document.querySelectorAll("[data-video] iframe"));

/**
 * title Smooth Scroll
 * description Makes any anchor links smooth scroll to relevant point on page
 */
import smoothScroll from "./modules/smooth-scroll";
smoothScroll();

/**
 * title Analytics
 * description Event tracking
 */
import analytics from "./modules/analytics";
analytics();

/**
 * title Text Size
 * description Allows user to increase text size
 */
import textSize from "./modules/text-size";
textSize();

/**
 * title Back To Top Bar
 * description Shows/hides the 'back to top' bar on specific scroll position
 */
import backToTopBar from "./modules/back-to-top-bar";
backToTopBar();

/**
 * title Search Modal
 * description Functionality to show/hide global search modal
 */
import searchModal from "./modules/search-modal";
searchModal();

/**
 * title: Navigation
 * description: JS for primary nav
 **/
import { initNavigation } from "./modules/navigation";
initNavigation();

/**
 * title: Page Contents
 * description: Makes sure that takes height of 'back-to-top' bar into account when scrolling to content headings
 **/
import pageContents from "./modules/page-contents.js";
pageContents();

import clearField from "./modules/clear-field.js";
clearField();

import accordion from "./modules/accordion";
accordion();

import jumpSelect from "./modules/jump-select";
jumpSelect();
